import { render, staticRenderFns } from "./TradersOffersAndDeals.vue?vue&type=template&id=2282e463&"
import script from "./TradersOffersAndDeals.vue?vue&type=script&lang=js&"
export * from "./TradersOffersAndDeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports